
import React from 'react'
import Page from '../components/Page'
import runewords from '../data/runewords';
import { IonList, IonItem, IonSearchbar, IonLabel, IonCheckbox, IonButton, IonIcon, IonSelect, IonSelectOption, IonRadio, IonRadioGroup } from '@ionic/react';
import RunewordListItem from '../components/RunewordListItem';
import { filter } from 'ionicons/icons';
import runes from '../data/runes';
import getMaxRuneLevel from '../utils/getMaxRuneLevel';

class Runewords extends React.Component {

  state = {
    runewords: [],
    searchText: '',
    filterOpen: false,
    ladderOnly: false,
    sort: 'favFirst',
    weaponsSelected: true,
    armorsSelected: true,
    shieldsSelected: true,
    helmsSelected: true
  }

  componentDidMount() {
    if(this.props.match.path == '/runewords') this.setState({runewords: runewords})
    if(this.props.match.path == '/finderResults') this.setState({runewords: window.foundRunewords})
  }

  renderFilter() {
    if(this.state.filterOpen) return (
      <IonList style={{marginBottom: 10}} >
        <IonRadioGroup allowEmptySelection value={this.state.weaponsSelected && "weapon"} onIonChange={e => this.setState({weaponsSelected: e.target.value == 'weapon'})}>
          <IonItem>
            <IonItem>Weapons</IonItem>
            <IonRadio slot="start" value="weapon" />
          </IonItem>
        </IonRadioGroup>
        <IonRadioGroup allowEmptySelection value={this.state.armorsSelected && "armor"} onIonChange={e => this.setState({armorsSelected: e.target.value == 'armor'})}>
          <IonItem>
            <IonItem>Armors</IonItem>
            <IonRadio slot="start" value="armor" />
          </IonItem>
        </IonRadioGroup>
        <IonRadioGroup allowEmptySelection value={this.state.shieldsSelected && "shield"} onIonChange={e => this.setState({shieldsSelected: e.target.value == 'shield'})}>
          <IonItem>
            <IonItem>Shields</IonItem>
            <IonRadio slot="start" value="shield" />
          </IonItem>
        </IonRadioGroup>
        <IonRadioGroup allowEmptySelection value={this.state.helmsSelected && "helm"} onIonChange={e => this.setState({helmsSelected: e.target.value == 'helm'})}>
          <IonItem>
            <IonItem>Helms</IonItem>
            <IonRadio slot="start" value="helm" />
          </IonItem>
        </IonRadioGroup>
        <IonItem>
          <IonLabel>Ladder only</IonLabel>
          <IonCheckbox slot="end" checked={this.state.ladderOnly} onIonChange={e => this.setState({ladderOnly: e.target.checked})} />
        </IonItem>
        <IonItem>
          <IonLabel>Sort</IonLabel>
          <IonSelect value={this.state.sort} onIonChange={e => this.setState({sort: e.target.value})}>
            <IonSelectOption value="alphabetically">Alphabetically</IonSelectOption>
            <IonSelectOption value="favFirst">Favourited first</IonSelectOption>
            <IonSelectOption value="popularFirst">Popular first</IonSelectOption>
            <IonSelectOption value="newFirst">New runewords first</IonSelectOption>
            <IonSelectOption value="highestruneslast">Low runes first</IonSelectOption>
            <IonSelectOption value="highestrunesfirst">High runes first</IonSelectOption>
          </IonSelect>
        </IonItem>
      </IonList>
    )
  }
  
  render() {

    const favRunewords = JSON.parse(localStorage.getItem('favRunewords'));

    // search filter
    let preFiltered = this.state.runewords.filter(r => {
      let searchText = r.name;
      searchText += r.attributes.join(" ");
      if(searchText.toLowerCase().includes(this.state.searchText.toLowerCase())) return true;
      return false;
    });

    // category filter
    let filtered = preFiltered.filter(r => {
      if(this.state.weaponsSelected && r.cat.includes('weapon')) return true; 
      if(this.state.armorsSelected && r.cat.includes('armor')) return true; 
      if(this.state.shieldsSelected && r.cat.includes('shield')) return true; 
      if(this.state.helmsSelected && r.cat.includes('helm')) return true; 
      return false
    })

    // ladder filter
    if(this.state.ladderOnly) {
      filtered = filtered.filter(r => r.ladderOnly || r.ladder)
    }

    // apply sort
    if(this.state.sort == 'favFirst') {
      filtered = filtered.sort((word1,word2) => {
        if(favRunewords.includes(word1.name) && !favRunewords.includes(word2.name)) return -1
        if(favRunewords.includes(word2.name) && !favRunewords.includes(word1.name)) return 1
        return 0;
      })
    }
    if(this.state.sort == 'popularFirst') {
      filtered = filtered.sort((word1,word2) => {
        if(word1.popular && !word2.popular) return -1
        if(word2.popular && !word1.popular) return 1
        return 0;
      })
    }
    if(this.state.sort == 'newFirst') {
      filtered = filtered.sort((word1,word2) => {
        if(word1.new && !word2.new) return -1
        if(word2.new && !word1.new) return 1
        return 0;
      })
    }
    else if(this.state.sort == 'highestruneslast') {
      filtered = filtered.sort((word1,word2) => { return getMaxRuneLevel(word1)-getMaxRuneLevel(word2)})
    }
    else if(this.state.sort == 'highestrunesfirst') {
      filtered = filtered.sort((word1,word2) => { return getMaxRuneLevel(word2)-getMaxRuneLevel(word1)})
    }
  
    return (
      <Page title="Runewords" large renderButtonsRight={() => {
        return <IonButton onClick={() => {
          this.setState({filterOpen: !this.state.filterOpen})
        }}><IonIcon icon={filter}/></IonButton>
      }}>
        <IonSearchbar value={this.state.searchText} onIonChange={e => this.setState({searchText: e.target.value})} />
        {this.renderFilter()}
        <IonList>
          {filtered.map((r,i) => <RunewordListItem key={i} runeword={r}/>)}
        </IonList>
      </Page>
    )
  }
}

export default Runewords;